import { Dialog, IconButton } from '@components'
import { X } from 'lucide-solid'
import { type Component, type JSX, type Setter, Show } from 'solid-js'
import { Portal } from 'solid-js/web'
import { css } from 'styled-system/css'
import { Box } from 'styled-system/jsx'
import type { SpacingToken } from 'styled-system/tokens'

interface DialogContainerProps {
	children: JSX.Element
	setIsOpen: (value: boolean) => void
	isOpen: boolean
	title?: string
	closeOnInteractOutside?: boolean
	description?: string
	padding?: SpacingToken
}

export const DialogContainer: Component<DialogContainerProps> = (props) => {
	return (
		<Dialog.Root
			closeOnInteractOutside={props.closeOnInteractOutside || true}
			open={props.isOpen}
			onOpenChange={({ open }) => props.setIsOpen(open)}
		>
			<Portal>
				<Dialog.Backdrop />
				<Dialog.Positioner overflow="hidden">
					<Dialog.Content
						p={props.padding || 8}
						display="grid"
					>
						<Show when={props.title}>
							<Dialog.Title>{props.title}</Dialog.Title>
						</Show>
						<Show when={props.description}>
							<Dialog.Description mt={2}>{props.description}</Dialog.Description>
						</Show>
						<Box>{props.children}</Box>
						<Dialog.Trigger
							m={1}
							asChild={(props) => (
								<IconButton
									{...props}
									class={css({
										position: 'absolute',
										top: '2',
										right: '2',
									})}
									colorPalette="bg"
									variant="solid"
									size="xs"
									h="6"
									w="6"
									minW="2px"
								>
									<X />
								</IconButton>
							)}
						/>
					</Dialog.Content>
				</Dialog.Positioner>
			</Portal>
		</Dialog.Root>
	)
}
